import { FAQSection } from '@src/quince-components/src'
import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import RichText from '@src/quince-site-common/src/domains/RichText'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'
import { useAppSelector } from '@src/quince-site-common/src/redux/hooks'
import { getProductPropertiesForTracking } from '@src/telemetry/getProductPropertiesForTracking'
import React, { useCallback } from 'react'

import BundlePageSectionProps from '../../../domains/BundlePageSectionProps'
import ProductPageSectionProps from '../../../domains/ProductPageSectionProps'

import styles from './faqSection.module.scss'

function FaqSection(props: ProductPageSectionProps | BundlePageSectionProps) {
  const product = 'bundle' in props ? props.bundle : props.product

  const faqSectionData = props.sectionData[CUSTOM_SECTION_TYPE.INFORMATION_BOXES]
  const title: RichText | undefined = faqSectionData.title
  const accordianData = faqSectionData.accordianData

  const selectedOptions = useAppSelector<ProductVariantOption[]>(pdpStateManager, pdpStateManager.getSelectedOptions)

  const productProperties = getProductPropertiesForTracking(product as Product)

  const getIsVisibleTrackParams = useCallback(() => {
    const productId = product.id
    const selectedColor = selectedOptions.filter(o => o.name == 'Color')?.[0]?.value
    const variants = productHelper.getVariantsForOptions(product, selectedOptions)
    return {
      // @i18n-ignore
      action: 'product_faq-section',
      value: true,
      context: {
        productId,
        selectedColor,
        contentContainerType: CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DETAILS,
        contentContainerName: CUSTOM_SECTION_CONTAINER_NAMES.FAQ_SECTION,
        // @i18n-ignore
        trackingId: 'product-faq-section',
        // @i18n-ignore
        contentContainerDisplayName: 'Product FAQ Section',
        productProperties,
      },
    }
  }, [product.id, selectedOptions.filter(o => o.name == 'Color')?.[0]?.value])

  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  if (title || accordianData.data.length > 0) {
    return (
      <div ref={trackIsVisibleRef}>
        <FAQSection
          header={title}
          accordianData={accordianData}
          className={styles.faqSection}
          headerClassName={styles.faqSection__header}
          showFirstQuestionExpanded
          productProperties={productProperties}
        />
      </div>
    )
  }

  return null
}

export default FaqSection
